import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import useCurrentLang from '@/hooks/useCurrentLang';
import styled from 'styled-components';

import PageContainer from '@/components/Container/PageContainer';
import { Flex, LoadingPage } from '@/layout';
import { Button } from '@/components/UI/Button';
import { Check } from '@/components/Icon';
import { theme } from '@/theme/Theme';
import { addUsetToSubAccount } from '@/api/auth.api';
import PATH from '@/router/path';

const Text = styled.p`
  font-size: ${(p) => p.theme.fontSizes.md};
  color: ${(p) => p.theme.colors.gray300};
`;

const FormWrapper = styled.div`
  width: 100%;
  max-width: 930px;
  height: 500px;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${(p) => p.theme.colors.light};
  border-radius: 15px;
  padding-top: 60px;
`;

const AddUserToSubAccount = () => {
  // @ts-ignore
  const { t } = useTranslation();
  const currentLang = useCurrentLang();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isSuccess, setIsSuccess] = useState<boolean | null>(null);

  const sendAccountApi = async (data: AddUserToSubAccountRequest) => {
    setIsLoading(true);
    try {
      const res = (await addUsetToSubAccount(data)).data;
      if (res.success) {
        setIsSuccess(true);
        // 成功後跳轉到登入頁面
        // navigate(`/${currentLang}/${PATH.auth.signIn}`);
      } else {
        setIsSuccess(false);
      }
    } catch (error) {
      setIsSuccess(false);
    } finally {
      setIsLoading(false);
    }
  }

  // 進入此頁面時要檢查網址是否帶有parameters
  // 需要解析出對應的參數並打包後發送addUsetToSubAccount api
  useEffect(() => {
    // 若進入時有缺少任何一個參數則跳轉回首頁
    const token = searchParams.get('token');
    const mainAccountId = searchParams.get('mainAccountId');
    const companyName = searchParams.get('companyName');
    const email = searchParams.get('email');
    if (!token || !mainAccountId || !companyName || !email) {
      navigate(`/${currentLang}`);
      return;
    }
    setSearchParams({}, { replace: true });
    // 若有參數則發送api
    sendAccountApi({
      token,
      mainAccountId,
      companyName,
      email,
    });

  }, [])

  return (
    <>
      <LoadingPage isLoading={isLoading} />

      <FormWrapper>
        <Flex flexDirection={'column'} gridGap={15} alignItems={'center'}>

          {isSuccess === null ? null : isSuccess ? (
              <Check.CheckSVG fill={theme.colors.success} width="96" height="96" />
            ) : (
              <Check.CancelSVG fill={theme.colors.danger} width="96" height="96" />
            )}
          <Text>
            {isSuccess === null ? null : isSuccess
                ? t('pages.addUserToSubAccount.success' as any)
                : t('pages.addUserToSubAccount.fail' as any)
            }
          </Text>
          <Text>
            {
              isSuccess && t('pages.addUserToSubAccount.successMsg' as any)
            }
          </Text>
        </Flex>
        <Flex gridGap={20} justifyContent={'center'} marginTop={50}>
          <Link to={PATH.auth.signIn}>
            <Button size={'lg'} variant={'primary'} rounded={false} width={250}>
              {t('buttons.signIn')}
            </Button>
          </Link>
        </Flex>
      </FormWrapper>
    </>
  );
};

export default AddUserToSubAccount;
